import { render } from "./formrow2.vue?vue&type=template&id=c67846d6"
import script from "./formrow2.vue?vue&type=script&lang=js"
export * from "./formrow2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__